import getReducer from '../getReducer';
import assign from 'object-assign';

import { PROCESS_GET_PROCESS_REQUEST, PROCESS_GET_PROCESS_SUCCESS, PROCESS_GET_PROCESS_FAILURE } from '../../action/process/getProcessDefinitions'
import { PROCESS_START_REQUEST, PROCESS_START_SUCCESS, PROCESS_START_FAILURE } from '../../action/process/startProcessinStance'
import { PROCESS_GET_DEFINITION_ID_REQUEST, PROCESS_GET_DEFINITION_ID_SUCCESS, PROCESS_GET_DEFINITION_ID_FAILURE } from '../../action/process/getProcessDefinitionId'
import { FILE_UPLOAD_REQUEST, FILE_UPLOAD_SUCCESS, FILE_UPLOAD_FAILURE } from '../../action/process/fileUpload'

import { PROCESS_MODAL_VISIBLE, CHANGE_WORKFLOW_STATE } from '../../action/process/mutations'

import { TASK_ASSIGNEE_REQUEST, TASK_ASSIGNEE_SUCCESS, TASK_ASSIGNEE_FAILURE } from '../../action/workflow/assignee'
import { TASK_ASSIGNEE_MUTATIONS } from '../../action/workflow/assignee'

import { TASK_ASSIGNEE_DETAIL_REQUEST, TASK_ASSIGNEE_DETAIL_SUCCESS, TASK_ASSIGNEE_DETAIL_FAILURE } from '../../action/workflow/assigneeDetail'
import { PROCESS_DETAIL_REQUEST, PROCESS_DETAIL_SUCCESS, PROCESS_DETAIL_FAILURE } from '../../action/workflow/processDetail'
import { TASK_CANDIDATE_REQUEST, TASK_CANDIDATE_SUCCESS, TASK_CANDIDATE_FAILURE } from '../../action/workflow/candidate'
import { TASK_COMPLETE_REQUEST, TASK_COMPLETE_SUCCESS, TASK_COMPLETE_FAILURE } from '../../action/workflow/complete'
import { HISTORY_PROCESS_REQUEST, HISTORY_PROCESS_SUCCESS, HISTORY_PROCESS_FAILURE } from '../../action/workflow/process'
import { PROCESS_ACTIVITY_LIST_REQUEST, PROCESS_ACTIVITY_LIST_SUCCESS, PROCESS_ACTIVITY_LIST_FAILURE } from '../../action/workflow/process'

import { PROCESS_RUNNING_REQUEST, PROCESS_RUNNING_SUCCESS, PROCESS_RUNNING_FAILURE } from '../../action/workflow/running'
import { HISTORY_TASK_REQUEST, HISTORY_TASK_SUCCESS, HISTORY_TASK_FAILURE } from '../../action/workflow/task'
import { TASK_CLAIM_REQUEST, TASK_CLAIM_SUCCESS, TASK_CLAIM_FAILURE } from '../../action/workflow/claim'
import { TASK_DELEGATE_REQUEST, TASK_DELEGATE_SUCCESS, TASK_DELEGATE_FAILURE } from '../../action/workflow/delegate'

import { TASK_REMINDERS_REQUEST, TASK_REMINDERS_SUCCESS, TASK_REMINDERS_FAILURE } from '../../action/workflow/reminders'
import { TASK_DELETE_REQUEST, TASK_DELETE_SUCCESS, TASK_DELETE_FAILURE } from '../../action/workflow/delete'

import { USER_GET_ALL_REQUEST, USER_GET_ALL_SUCCESS, USER_GET_ALL_FAILURE } from '../../action/user/getall'
import { PROCESS_START_YEARDAYS_REQUEST, PROCESS_START_YEARDAYS_SUCCESS, PROCESS_START_YEARDAYS_FAILURE } from '../../action/process/yearDays'

import { DEPARTMENT_TREE_REQUEST, DEPARTMENT_TREE_SUCCESS, DEPARTMENT_TREE_FAILURE } from '../../action/department/tree'
import { POSITION_GET_ALL_REQUEST, POSITION_GET_ALL_SUCCESS, POSITION_GET_ALL_FAILURE } from '../../action/position/getall'

import { NEED_PERSON_LIST_REQUEST, NEED_PERSON_LIST_SUCCESS, NEED_PERSON_LIST_FAILURE } from '../../action/recruitment/needPersonList'
import { MY_INVOLVED_TASK_REQUEST, MY_INVOLVED_TASK_SUCCESS, MY_INVOLVED_TASK_FAILURE } from '../../action/workflow/myInvolved'

// HR
import { USER_GET_BY_ROLENAME_REQUEST, USER_GET_BY_ROLENAME_SUCCESS, USER_GET_BY_ROLENAME_FAILURE } from '../../action/user/getUserByRoleName'
import { USER_GET_TRY_USER_REQUEST, USER_GET_TRY_USER_SUCCESS, USER_GET_TRY_USER_FAILURE } from '../../action/user/getTryUsers'

import { ADJUST_DAYS_REQUEST, ADJUST_DAYS_SUCCESS, ADJUST_DAYS_FAILURE } from '../../action/workflow/getAdjustDays'
import { PICK_SICK_DAYS_REQUEST, PICK_SICK_DAYS_SUCCESS, PICK_SICK_DAYS_FAILURE } from '../../action/workflow/getPickSickDays'

//authorization
import { INSERT_AUTHORIZATION_REQUEST, INSERT_AUTHORIZATION_SUCCESS, INSERT_AUTHORIZATION_FAILURE } from '../../action/workflow/authorization'
import { UPDATE_AUTHORIZATION_REQUEST, UPDATE_AUTHORIZATION_SUCCESS, UPDATE_AUTHORIZATION_FAILURE } from '../../action/workflow/authorization'
import { DELETE_AUTHORIZATION_REQUEST, DELETE_AUTHORIZATION_SUCCESS, DELETE_AUTHORIZATION_FAILURE } from '../../action/workflow/authorization'
import { CLOSE_AUTHORIZATION_REQUEST, CLOSE_AUTHORIZATION_SUCCESS, CLOSE_AUTHORIZATION_FAILURE } from '../../action/workflow/authorization'
import { OPEN_AUTHORIZATION_REQUEST, OPEN_AUTHORIZATION_SUCCESS, OPEN_AUTHORIZATION_FAILURE } from '../../action/workflow/authorization'
import { MY_AUTHORIZATION_REQUEST, MY_AUTHORIZATION_SUCCESS, MY_AUTHORIZATION_FAILURE } from '../../action/workflow/authorization'
import { AUTHORIZATION_DETAIL_REQUEST, AUTHORIZATION_DETAIL_SUCCESS, AUTHORIZATION_DETAIL_FAILURE } from '../../action/workflow/authorization'
import { AUTHORIZATION_LIST_REQUEST, AUTHORIZATION_LIST_SUCCESS, AUTHORIZATION_LIST_FAILURE } from '../../action/workflow/authorization'

import { GET_CONTRACT_TYPES_REQUEST, GET_CONTRACT_TYPES_SUCCESS, GET_CONTRACT_TYPES_FAILURE } from '../../action/process/contractStartForm'

import { PROJECT_LIST_REQUEST, PROJECT_LIST_SUCCESS, PROJECT_LIST_FAILURE } from '../../action/project_manager/project'
import { PROCESS_DEFINITION_LIST_REQUEST, PROCESS_DEFINITION_LIST_SUCCESS, PROCESS_DEFINITION_LIST_FAILURE } from '../../action/workflow/process'


function workflow(state = {
  showLoading: false,
  visible: false,
  // 我的任务/待处理
  formKey: '',
  processDefinitionId: '',
  assignee: {
    visible: false,
    pageSize: 10,
    data: [],
    total: 0,
    taskId: '',
    // 当前页返回的数据条数
    size: 0
  },
  // 我的任务/已完成
  processedTask: {
    total: 0,
    pageSize: 10,
    data: [],
    size: 0
  },
  // 我的任务/待签收
  candidateTask: {
    total: 0,
    pageSize: 10,
    data: [],
    size: 0
  },
  // 我的流程/处理中
  runningApply: {
    total: 0,
    pageSize: 10,
    data: [],
    size: 0
  },
  // 我的流程/已完成
  processApply: {
    total: 0,
    pageSize: 10,
    data: [],
    size: 0
  },
  // 我参与的流程
  myInvolved: {
    total: 0,
    page: 1,
    data: [],
    size: 10
  },
  // 任务详情
  assigneeDetail: {},
  // 流程详情
  processDetail: {},
  // 所有部门
  departmentTree: [],
  // 所有职位
  positions: [],
  // 所有员工
  allUsers: [],
  needPersonList: [],
  hrList: [],
  // 调休天数
  adjustDays: 0,
  // 年假天数
  yeardays: 0,
  // 带薪病假天数
  pickSickDays: 0,
  // 试用期员工
  tryUsers: [],
  myAuthorizationList: [],
  authorizationList: [],
  processActivityList: [],
  authorizationDetail: null,
  contractTypes: [],
  project: [],
  definitions: []
}, action) {
  switch (action.type) {
    // 获取所有可用流程
    case PROCESS_GET_PROCESS_REQUEST:
      return assign({}, state, { showLoading: true })
    case PROCESS_GET_PROCESS_SUCCESS:
      return assign({}, state, {
        processDefinitions: action.response.result,
        showLoading: false
      })
    case PROCESS_GET_PROCESS_FAILURE:
      return assign({}, state, { showLoading: false })

    // 获取processDefinitionId
    case PROCESS_GET_DEFINITION_ID_REQUEST:
      return assign({}, state, { showLoading: true })
    case PROCESS_GET_DEFINITION_ID_SUCCESS:
      return assign({}, state, {
        formKey: action.response.result.formKey,
        processDefinitionId: action.response.result.processDefinitionId,
        showLoading: false
      })
    case PROCESS_GET_DEFINITION_ID_FAILURE:
      return assign({}, state, { showLoading: false })

    // 启动流程实例
    case PROCESS_START_REQUEST:
      return assign({}, state, { showLoading: true })
    case PROCESS_START_SUCCESS:
      return assign({}, state, {
        processinStance: action.response.result,
        showLoading: false
      })
    case PROCESS_START_FAILURE:
      return assign({}, state, { showLoading: false })

    // 关闭打开form_modal
    case PROCESS_MODAL_VISIBLE:
      return assign({}, state, {
        visible: action.visible
      })

    case PROCESS_ACTIVITY_LIST_REQUEST:
      return assign({}, state, { showLoading: true })
    case PROCESS_ACTIVITY_LIST_SUCCESS:
      return assign({}, state, {
        showLoading: false,
        processActivityList: action.response.result
      })
    case PROCESS_ACTIVITY_LIST_FAILURE:
      return assign({}, state, { showLoading: false })
    // 同步的action
    case CHANGE_WORKFLOW_STATE:
      return assign({}, state, action.payload)

    // 附件上传
    case FILE_UPLOAD_REQUEST:
      return assign({}, state, { showLoading: true })
    case FILE_UPLOAD_SUCCESS:
      return assign({}, state, { showLoading: false })
    case FILE_UPLOAD_FAILURE:
      return assign({}, state, { showLoading: false })

    // 待办任务
    case TASK_ASSIGNEE_REQUEST:
      return assign({}, state, { showLoading: true })
    case TASK_ASSIGNEE_SUCCESS:
      return assign({}, state, {
        assignee: assign({}, state.assignee, action.response.result),
        showLoading: false
      })
    case TASK_ASSIGNEE_FAILURE:
      return assign({}, state, { showLoading: false })

    case TASK_ASSIGNEE_MUTATIONS:
      return assign({}, state, { assignee: assign({}, state.assignee, action.payload) })

    // 待办任务详情
    case TASK_ASSIGNEE_DETAIL_REQUEST:
      return assign({}, state, { showLoading: true })
    case TASK_ASSIGNEE_DETAIL_SUCCESS:
      return assign({}, state, {
        assigneeDetail: action.response.result,
        showLoading: false
      })
    case TASK_ASSIGNEE_DETAIL_FAILURE:
      return assign({}, state, { showLoading: false })

    // 待办流程详情
    case PROCESS_DETAIL_REQUEST:
      return assign({}, state, { showLoading: true })
    case PROCESS_DETAIL_SUCCESS:
      let obj = assign({}, state, {
        showLoading: false,
        processDetail: action.response.result
      })
      console.log('obj-------------',obj);
      return obj;
    case PROCESS_DETAIL_FAILURE:
      return assign({}, state, { showLoading: false })

    // 待领任务
    case TASK_CANDIDATE_REQUEST:
      return assign({}, state, { showLoading: true })
    case TASK_CANDIDATE_SUCCESS:
      return assign({}, state, {
        candidateTask: action.response.result,
        showLoading: false
      })
    case TASK_CANDIDATE_FAILURE:
      return assign({}, state, { showLoading: false })

    // 完成任务
    case TASK_COMPLETE_REQUEST:
      return assign({}, state, { showLoading: true })
    case TASK_COMPLETE_SUCCESS:
      return assign({}, state, {
        complete: action.response.result,
        showLoading: false
      })
    case TASK_COMPLETE_FAILURE:
      return assign({}, state, { showLoading: false })

    // 已经结束流程
    case HISTORY_PROCESS_REQUEST:
      return assign({}, state, { showLoading: true })
    case HISTORY_PROCESS_SUCCESS:
      return assign({}, state, {
        processApply: assign({}, state.processApply, action.response.result),
        showLoading: false
      })
    case HISTORY_PROCESS_FAILURE:
      return assign({}, state, { showLoading: false })

    // 处理中流程
    case PROCESS_RUNNING_REQUEST:
      return assign({}, state, { showLoading: true })
    case PROCESS_RUNNING_SUCCESS:
      return assign({}, state, {
        runningApply: assign({}, state.runningApply, action.response.result),
        showLoading: false
      })
    case PROCESS_RUNNING_FAILURE:
      return assign({}, state, { showLoading: false })

    // 已办任务
    case HISTORY_TASK_REQUEST:
      return assign({}, state, { showLoading: true })
    case HISTORY_TASK_SUCCESS:
      return assign({}, state, {
        processedTask: assign({}, state.processedTask, action.response.result),
        showLoading: false
      })
    case HISTORY_TASK_FAILURE:
      return assign({}, state, { showLoading: false })

    // 我参与的流程
    case MY_INVOLVED_TASK_REQUEST:
      return assign({}, state, { showLoading: true })
    case MY_INVOLVED_TASK_SUCCESS:
      return assign({}, state, {
        myInvolved: assign({}, state.myInvolved, action.response.result),
        showLoading: false
      })
    case MY_INVOLVED_TASK_FAILURE:
      return assign({}, state, { showLoading: false })

    // 签收任务
    case TASK_CLAIM_REQUEST:
      return assign({}, state, { showLoading: true })
    case TASK_CLAIM_SUCCESS:
      return assign({}, state, { showLoading: false })
    case TASK_CLAIM_FAILURE:
      return assign({}, state, { showLoading: false })

    // 转发任务
    case TASK_DELEGATE_REQUEST:
      return assign({}, state, { showLoading: true })
    case TASK_DELEGATE_SUCCESS:
      return assign({}, state, { showLoading: false })
    case TASK_DELEGATE_FAILURE:
      return assign({}, state, { showLoading: false })

    case TASK_REMINDERS_REQUEST:
      return assign({}, state, { showLoading: true })
    case TASK_REMINDERS_SUCCESS:
      return assign({}, state, { showLoading: false })
    case TASK_REMINDERS_FAILURE:
      return assign({}, state, { showLoading: false })

    // 删除任务
    case TASK_DELETE_REQUEST:
      return assign({}, state, { showLoading: true })
    case TASK_DELETE_SUCCESS:
      return assign({}, state, { showLoading: false })
    case TASK_DELETE_FAILURE:
      return assign({}, state, { showLoading: false })

    // 获取所有员工
    case USER_GET_ALL_REQUEST:
      return assign({}, state, { showLoading: true })
    case USER_GET_ALL_SUCCESS:
      return assign({}, state, {
        allUsers: action.response.result.users,
        showLoading: false
      })
    case USER_GET_ALL_FAILURE:
      return assign({}, state, {
        showLoading: false
      })

    // 获取年假数
    case PROCESS_START_YEARDAYS_REQUEST:
      return assign({}, state, { showLoading: true })
    case PROCESS_START_YEARDAYS_SUCCESS:
      return assign({}, state, {
        yeardays: action.response.result.days,
        showLoading: false
      })
    case PROCESS_START_YEARDAYS_FAILURE:
      return assign({}, state, { showLoading: false })

    // 获取所有职位
    case POSITION_GET_ALL_REQUEST:
      return assign({}, state, { showLoading: true })
    case POSITION_GET_ALL_SUCCESS:
      return assign({}, state, {
        positions: action.response.result.positions,
        showLoading: false
      })
    case POSITION_GET_ALL_FAILURE:
      return assign({}, state, { showLoading: false })

    // 获取所有部门
    case DEPARTMENT_TREE_REQUEST:
      return assign({}, state, { showLoading: true })
    case DEPARTMENT_TREE_SUCCESS:
      return assign({}, state, {
        departmentTree: action.response.result.departmentTree,
        showLoading: false
      })
    case DEPARTMENT_TREE_FAILURE:
      return assign({}, state, { showLoading: false })

    // 需求人员列表
    case NEED_PERSON_LIST_REQUEST:
      return assign({}, state, { showLoading: true })
    case NEED_PERSON_LIST_SUCCESS:
      return assign({}, state, {
        needPersonList: action.response.result.data,
        showLoading: false
      })
    case NEED_PERSON_LIST_FAILURE:
      return assign({}, state, { showLoading: false })

    // hr
    case USER_GET_BY_ROLENAME_REQUEST:
      return assign({}, state, {})
    case USER_GET_BY_ROLENAME_SUCCESS:
      return assign({}, state, {
        hrList: action.response.result,
      })
    case USER_GET_BY_ROLENAME_FAILURE:
      return assign({}, state, {})

    // 试用期员工
    case USER_GET_TRY_USER_REQUEST:
      return assign({}, state, {})
    case USER_GET_TRY_USER_SUCCESS:
      return assign({}, state, {
        tryUsers: action.response.result.users,
      })
    case USER_GET_TRY_USER_FAILURE:
      return assign({}, state, {})

    // 获取调休天数
    case ADJUST_DAYS_REQUEST:
      return assign({}, state, { showLoading: true })
    case ADJUST_DAYS_SUCCESS:
      return assign({}, state, {
        adjustDays: action.response.result.days,
        showLoading: false
      })
    case ADJUST_DAYS_FAILURE:
      return assign({}, state, { showLoading: false })

    // 获取带薪病假天数
    case PICK_SICK_DAYS_REQUEST:
      return assign({}, state, { showLoading: true })
    case PICK_SICK_DAYS_SUCCESS:
      return assign({}, state, {
        pickSickDays: action.response.result.days,
        showLoading: false
      })
    case PICK_SICK_DAYS_FAILURE:
      return assign({}, state, { showLoading: false })

    //授权
    case INSERT_AUTHORIZATION_REQUEST:
      return assign({}, state, { showLoading: true })
    case INSERT_AUTHORIZATION_SUCCESS:
      return assign({}, state, { showLoading: false })
    case INSERT_AUTHORIZATION_FAILURE:
      return assign({}, state, { showLoading: false })

    case INSERT_AUTHORIZATION_REQUEST:
      return assign({}, state, { showLoading: true })
    case UPDATE_AUTHORIZATION_SUCCESS:
      return assign({}, state, { showLoading: false })
    case UPDATE_AUTHORIZATION_FAILURE:
      return assign({}, state, { showLoading: false })

    case CLOSE_AUTHORIZATION_REQUEST:
      return assign({}, state, { showLoading: true })
    case CLOSE_AUTHORIZATION_SUCCESS:
      return assign({}, state, { showLoading: false })
    case CLOSE_AUTHORIZATION_FAILURE:
      return assign({}, state, { showLoading: false })

    case OPEN_AUTHORIZATION_REQUEST:
      return assign({}, state, { showLoading: true })
    case OPEN_AUTHORIZATION_SUCCESS:
      return assign({}, state, { showLoading: false })
    case OPEN_AUTHORIZATION_FAILURE:
      return assign({}, state, { showLoading: false })

    case DELETE_AUTHORIZATION_REQUEST:
      return assign({}, state, { showLoading: true })
    case DELETE_AUTHORIZATION_SUCCESS:
      return assign({}, state, { showLoading: false })
    case DELETE_AUTHORIZATION_FAILURE:
      return assign({}, state, { showLoading: false })

    case MY_AUTHORIZATION_REQUEST:
      return assign({}, state, { showLoading: true })
    case MY_AUTHORIZATION_SUCCESS:
      return assign({}, state, {
        showLoading: false,
        myAuthorizationList: action.response.result.data
      })
    case MY_AUTHORIZATION_FAILURE:
      return assign({}, state, { showLoading: false })

    case AUTHORIZATION_DETAIL_REQUEST:
      return assign({}, state, { showLoading: true })
    case AUTHORIZATION_DETAIL_SUCCESS:
      return assign({}, state, {
        showLoading: false,
        authorizationDetail: action.response.result.data
      })
    case AUTHORIZATION_DETAIL_FAILURE:
      return assign({}, state, { showLoading: false })

    case AUTHORIZATION_LIST_REQUEST:
      return assign({}, state, { showLoading: true })
    case AUTHORIZATION_LIST_SUCCESS:
      return assign({}, state, {
        showLoading: false,
        authorizationList: action.response.result.data || []
      })
    case AUTHORIZATION_LIST_FAILURE:
      return assign({}, state, { showLoading: false })

    case GET_CONTRACT_TYPES_REQUEST:
      return assign({}, state, { showLoading: true })
    case GET_CONTRACT_TYPES_SUCCESS:
      return assign({}, state, {
        contractTypes: action.response.result.contractTypes || [],
        showLoading: false
      })
    case GET_CONTRACT_TYPES_FAILURE:
      return assign({}, state, { showLoading: false })
    case PROJECT_LIST_REQUEST:
      return assign({}, state, { showLoading: true })
    case PROJECT_LIST_SUCCESS:
      return assign({}, state, {
        project: action.response.result.project || [],
        showLoading: false
      })
    case PROJECT_LIST_FAILURE:
      return assign({}, state, { showLoading: false })
    case PROCESS_DEFINITION_LIST_REQUEST:
      return assign({}, state, { showLoading: true })
    case PROCESS_DEFINITION_LIST_SUCCESS:
      return assign({}, state, {
        definitions: action.response.result || [],
        showLoading: false
      })
    case PROCESS_DEFINITION_LIST_FAILURE:
      return assign({}, state, { showLoading: false })
    default:
      return state;
  }
}

export default getReducer(workflow);


// WEBPACK FOOTER //
// ./src/reducer/workflow/index.js